import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { Text } from "../../components/units/Text"
import { useParams } from 'react-router-dom';


export const ErrorPage = () => {
    const { error_code } = useParams<{ error_code: string }>();
    return (
        <ContentWrapper>
            <Text>Возникла ошибка {error_code}</Text>
        </ContentWrapper>
    )
}